import { benchImageComponentService } from '../helpers/benchImageComponentService';
import { convertCoordinatesToWallBasedPositioning } from '../helpers/stovePositionConverter'

let rendererlib = document.benchRendererLib;



let renderCadImage = (state, components) => {
    return new Promise((resolve,reject) => {
        var benchModel = {
            straightAtBackWall: state.benchModel.shape.straightAtBackWall,
            straightAtLeftWall: state.benchModel.shape.straightAtLeftWall,
            straightAtRightWall: state.benchModel.shape.straightAtRightWall,
            straightAtFrontWall: state.benchModel.shape.straightAtFrontWall,
            stoveEmbedding: state.benchModel.shape.stoveEmbedding,
            stoolHoleArcRadius: state.benchModel.model.stoolHoleArcRadius,
            upperBenchDepth: state.benchModel.model.upperBenchDepth,
            cornerSize: 900,
            profileColor: "#C19169"
        };

        var c = document.createElement("canvas");
        c.width = 1000;
        c.height = 1000;
         
        c.width = c.width;
        var context = c.getContext("2d");
        let imageComponents = state.benchModel.imageComponents; 
        let doorFromLeft = state.measurements.doorFromLeft;
        let stovePosition = convertCoordinatesToWallBasedPositioning(state.measurements, state.benchModel.shape.mirrored || state.benchModel.mirrored);
        if (state.benchModel.shape.mirrored || state.benchModel.mirrored) {
            context.translate(state.measurements.doorWallWidth / 3, 0);
            context.scale(-1, 1);
            doorFromLeft = state.measurements.doorWallWidth - state.measurements.doorWidth - state.measurements.doorFromLeft;
        }
        let renderer = new rendererlib.saunaRenderer(  
            state.measurements.doorWallWidth,
            state.measurements.depth,
            state.measurements.doorWidth,
            doorFromLeft,
            stovePosition.stoveWall,
            stovePosition.stoveFromLeft,            
            imageComponents.backLeftCornerImg,
            imageComponents.backRightCornerImg,
            imageComponents.frontRightCornerImg,
            imageComponents.frontLeftCornerImg,
            imageComponents.backwallLeftImg,
            imageComponents.backwallRightImg,
            imageComponents.rightwallImg,
            imageComponents.leftwallImg,
            imageComponents.bottomBenchImage,
            context);
        renderer.stoolImage = imageComponents.stoolImage;      
        renderer.benchModel = benchModel;
        renderer.s_drawBottomBench = state.benchModel.model.drawBottomBench;

        renderer.drawingController.drawSauna(renderer);

        try {
            resolve(c.toDataURL());
        }
        catch (err) {            
            reject(err);
        }
    });
};



export const updateCadImage = (bench) => {
    return (dispatch, getState) => {
        let state = getState();
        if (state.clientConfiguration.drawBenchCadPicture && state.benchModel.model.supportsCadDrawing && !state.measurements.positioningSkipped) {
            benchImageComponentService(state).then(c => downLoadImages(c, c => {
                c.scale = 3;
                dispatch(benchImageComponentsUpdated(c));
            }));
        }
    }
}

let downLoadImages = (images,callback) =>
{
    let entries = Object.entries(images)
    let remainingCount = entries.length;
    let result = {};
    entries.forEach(([propertyName, url]) => {
        if (url) {
            let image = new Image();
            image.crossOrigin = true;
            image.onload =() => {
                result[propertyName] = image;
                remainingCount--;
                if (remainingCount === 0) {
                    callback(result);
                }
            }
            image.onerror = () => {
                remainingCount--;
                result[propertyName] = "";
                if (remainingCount === 0) {
                    callback(result);
                }
            }
            image.src = url;
        }
        else {
            remainingCount--;
            if (remainingCount === 0) {
                result[propertyName] = "";
                callback(result);
            }           
        }
    });
}


export const benchImageComponentsUpdated = (components) => {
    return ((dispatch, getState) => {
        dispatch({
            type: 'BENCH_IMAGECOMPONENTS_UPDATED',
            components: {
                backLeftCornerImg: components.BackLeftCornerImg || components.backLeftCornerImg,
                backRightCornerImg: components.BackRightCornerImg || components.backRightCornerImg,
                frontRightCornerImg: components.FrontRightCornerImg || components.frontRightCornerImg,
                frontLeftCornerImg: components.FrontLeftCornerImg || components.frontLeftCornerImg,
                backwallLeftImg: components.BackwallLeftImg || components.backwallLeftImg,
                backwallRightImg: components.BackwallRightImg || components.backwallRightImg,
                rightwallImg: components.RightwallImg || components.rightwallImg,
                leftwallImg: components.LeftwallImg || components.leftwallImg,
                bottomBenchImage: components.BottomBenchImage || components.bottomBenchImage,
                stoolImage: components.StoolImage || components.stoolImage,
                stoveImage: components.StoveImage || components.stoveImage,
                scale: components.scale
            }
        });
        let state = getState();
        renderCadImage(state, components).then(i => dispatch(benchCadImageRenderComplete(i,components.scale)));
    })
}

export const benchCadImageRenderComplete = (image, scale) => ({
    type: "BENCHCADIMAGE_RENDERCOMPLETE",
    image: image,
    scale: scale
});

